<template>
  <page-template>
    <template slot="page-content">
      <div class="generic--template page-template">
        <!-- CONTENT -->
        <div class="relative z-content pt4">
          <div class="relative container-fluid mw9 center">
            <div class="row relative center tl">
              <h1 class="f-page-title ttu tl lh-title f2 f1-ns is-blenny is-navy">
                {{ page.title }}
              </h1>
            </div>
          </div>
          <section class="relative">
            <div class="relative container-fluid mw9 center">
              <div class="relative mv3 cms-content" v-html="marked(page.content)"></div>
              <div class="row center">
                <div class="col-xs-12 col-sm-9 mt4 mt5-ns">
                  <div class="row">
                    <div class="col-xs-12 col-sm-8 pb5">
                      <p
                        class="f22px is-tablet-regular link-bold lh-copy"
                        v-html="page.intro_text"
                      ></p>
                    </div>
                  </div>
                  <div class="row">
                    <div
                      class="col-xs-12 col-sm-6 pb5"
                      v-for="(block, index) in page.content_blocks"
                      :key="index"
                    >
                      <h3 class="f20px is-tablet-bold mb3" v-html="block.title"></h3>
                      <p
                        class="f15px is-tablet-regular link-bold lh-copy"
                        v-html="block.text"
                      ></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div
          class="relative bg-light-blue z-content mb5"
          v-if="isWindowWidthMobile == true && page.featured_content_section.is_published"
        >
          <section class="relative center pv4 is-black">
            <swiper :options="swiperOptions" ref="mySwiper">
              <swiper-slide>
                <div class="relative container-fluid">
                  <div class="db w-100">
                    <img
                      class="db relative center img-responsive w-100"
                      :src="page.featured_content_section.content['0'].image"
                      :alt="page.featured_content_section.content['0'].image.alt"
                    />
                    <h3 class="f20px is-tablet-cond-bold mt4 mb3">
                      {{ page.featured_content_section.content["0"].title }}
                    </h3>
                    <p class="f15px is-tablet-regular mb3 lh-copy">
                      {{ page.featured_content_section.content["0"].text }}
                    </p>
                    <a
                      class="f15px is-tablet-bold"
                      :title="page.featured_content_section.content['0'].link_title"
                      :href="page.featured_content_section.content['0'].link"
                      >{{ page.featured_content_section.content["0"].button_text
                      }}<simple-svg
                        class="checkout"
                        :filepath="'/uploads/checkout-arrow.svg'"
                      ></simple-svg
                    ></a>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="relative container-fluid">
                  <div class="db w-100">
                    <img
                      class="db relative center img-responsive w-100"
                      :src="page.featured_content_section.content['1'].image"
                      :alt="page.featured_content_section.content['1'].image.alt"
                    />
                    <h3 class="f20px is-tablet-cond-bold mt4 mb3">
                      {{ page.featured_content_section.content["1"].title }}
                    </h3>
                    <p class="f15px is-tablet-regular mb3 lh-copy">
                      {{ page.featured_content_section.content["1"].text }}
                    </p>
                    <a
                      class="f15px is-tablet-bold"
                      :title="page.featured_content_section.content['1'].link_title"
                      :href="page.featured_content_section.content['1'].link"
                      >{{ page.featured_content_section.content["1"].button_text
                      }}<simple-svg
                        class="checkout"
                        :filepath="'/uploads/checkout-arrow.svg'"
                      ></simple-svg
                    ></a>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </section>
        </div>

        <div
          class="relative bg-light-blue z-content mb5 mt4"
          v-if="
            isWindowWidthMobile == false && page.featured_content_section.is_published
          "
        >
          <div class="relative container-fluid">
            <section class="relative center mw8 pt5 pb5 is-black">
              <div class="row">
                <div class="col-xs-12 col-sm-6 pr5-ns br-ns b--is-cream">
                  <img
                    class="db relative center img-responsive w-100"
                    :src="page.featured_content_section.content['0'].image"
                    :alt="page.featured_content_section.content['0'].image.alt"
                  />
                  <h3 class="f20px is-tablet-cond-bold mt4 mb3">
                    {{ page.featured_content_section.content["0"].title }}
                  </h3>
                  <p class="f15px is-tablet-regular mb3 lh-copy">
                    {{ page.featured_content_section.content["0"].text }}
                  </p>
                  <a
                    class="f15px is-tablet-bold"
                    :title="page.featured_content_section.content['0'].link_title"
                    :href="page.featured_content_section.content['0'].link"
                    >{{ page.featured_content_section.content["0"].button_text
                    }}<simple-svg
                      class="checkout"
                      :filepath="'/uploads/checkout-arrow.svg'"
                    ></simple-svg
                  ></a>
                </div>
                <div class="col-xs-12 col-sm-6 pl5-ns pt5 pt0-m pt0-l">
                  <img
                    class="db relative center img-responsive w-100 pt4 pt0-m pt0-l"
                    :src="page.featured_content_section.content['1'].image"
                    :alt="page.featured_content_section.content['1'].image.alt"
                  />
                  <h3 class="f20px is-tablet-cond-bold mt4 mb3">
                    {{ page.featured_content_section.content["1"].title }}
                  </h3>
                  <p class="f15px is-tablet-regular mb3 lh-copy">
                    {{ page.featured_content_section.content["1"].text }}
                  </p>
                  <a
                    class="f15px is-tablet-bold"
                    :title="page.featured_content_section.content['1'].link_title"
                    :href="page.featured_content_section.content['1'].link"
                    >{{ page.featured_content_section.content["1"].button_text
                    }}<simple-svg
                      class="checkout"
                      :filepath="'/uploads/checkout-arrow.svg'"
                    ></simple-svg
                  ></a>
                </div>
              </div>
            </section>
          </div>
        </div>

        <!-- <div class="relative z-content">
          <img class="absolute" :style="calcParallax('tasteBubble', 200, 800, 'right:-70px;')" src="/uploads/tastebubble.svg" ref="tasteBubble" />
          <img class="absolute" :style="calcParallax('leftBubble', 650, 120, 'left:-120px;')" src="/uploads/left-bubble.svg" ref="leftBubble" />
        </div>

        <div class="w-100 pb5 flex flex-column ">
          <div class="bg-blue-after pv5 relative">
            <div class="flex flex-column container-fluid relative z-4">
              <h2 class="f30px is-white center tc ttu lh-copy is-lorano-bold pv4 dib" id="clusterfest-app">WE’LL SEND YOU THE LATEST.<img class="dib megaphone" src="/uploads/OL19_Megaphone.svg" /></h2>
              <signup-form class="w-100 mw6 dib"></signup-form>
            </div>
          </div>
        </div>

        <div class="relative z-3">
          <img class="absolute" :style="calcParallax('smallBubble', -250, 350, 'right:4vw;')" src="/uploads/small-bubble-optim.png" ref="smallBubble" />
          <img class="absolute" :style="{'top':parallax + 'px', 'display': 'none'}" src="" />
        </div> -->
      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from "./page-template.vue";
// import SignupForm from './signup-form.vue';
import BgVimeoVideo from "./bg-vimeo-video.vue";
export default {
  components: {
    PageTemplate,
    // SignupForm,
    BgVimeoVideo,
  },
  props: ["id", "pageMarkdownFileName"],
  metaInfo() {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        return titleChunk
          ? `${titleChunk} | ` + this.$site_seo_title_suffix
          : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: "description", name: "description", content: this.page.seo_description },
      ],
    };
  },
  data() {
    return {
      bgOpaciy: 0,
      bgScrollStart: this.$bgScrollStart,
      scrollPos: 0,
      parallax: null,
      parallax2: true,
      window: {
        width: 0,
        height: 0,
      },
      isWindowWidthMobile: null,
      swiperOptions: {
        autoplay: {
          delay: 7000,
        },
        speed: 800,
        autoplayDisableOnInteraction: false,
        // loop: true,
        initialSlide: 0,
        //pagination: '.swiper-pagination',
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: false,
        },
        keyboardControl: true,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        initialSlide: 0,
        spaceBetween: 15,
        freeMode: false,
        slidesPerView: 1.3,
      },
    };
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName(this.pageMarkdownFileName);
      return pageData[0];
    },
    swiper() {
      if (this.$refs.mySwiper) return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    scrollBg: function () {
      if (window.scrollY > this.bgScrollStart) {
        //console.log('scrollBg', window.scrollY, this.bgOpaciy);
        if (document.body.getBoundingClientRect().top > this.scrollPos) {
          //this.bgOpaciy = 0 + (1 - window.scrollY * 0.001);
          if (window.scrollY > this.bgScrollStart) {
            this.bgOpaciy = window.scrollY * 0.001;
            //console.log('SCROLL UP: ', window.scrollY, this.bgOpaciy);
          } else {
            this.bgOpacity = 0;
          }
        } else {
          //this.bgOpaciy = this.bgOpaciy - (window.scrollY * (0.0001));
          this.bgOpaciy = window.scrollY * 0.001;
          //console.log('SCROLL DOWN: ', window.scrollY, this.bgOpaciy);
        }
        // saves the new position for iteration.
        this.scrollPos = document.body.getBoundingClientRect().top;
      } else {
        this.bgOpaciy = 0;
      }
    },
    sizing: function () {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768) this.isWindowWidthMobile = true;
      else {
        this.isWindowWidthMobile = false;
        this.mobileActive = -1;
      }
      //this.scrollBg();
      if (this.swiper) this.swiper.update();
    },
    calcParallax: function (myTarget, offset, movement, positioning) {
      if (this.$refs[myTarget]) {
        this.parallax2 = false;
        if (
          this.$refs[myTarget].parentElement.getBoundingClientRect().y +
            offset +
            this.$refs[myTarget].getBoundingClientRect().height +
            movement >
            0 &&
          this.$refs[myTarget].parentElement.getBoundingClientRect().y +
            offset -
            movement <
            window.innerHeight
        ) {
          var newMovement =
            offset +
            ((this.$refs[myTarget].parentElement.getBoundingClientRect().y +
              offset +
              this.$refs[myTarget].getBoundingClientRect().height / 2 -
              window.innerHeight / 2 -
              27) /
              window.innerHeight) *
              movement;
          return "top:" + newMovement + "px;" + positioning;
        } else {
          return "display:none;";
        }
      }
    },
  },
  created() {
    var w = window.innerWidth;
    if (w < 768) {
      this.isWindowWidthMobile = true;
    } else {
      this.isWindowWidthMobile = false;
    }
    window.addEventListener("resize", this.sizing);
    window.addEventListener("scroll", this.scrollBg);
    window.addEventListener("load", this.sizing);
  },
  beforeMount() {
    //
  },
  mounted() {
    setInterval(() => {
      if (this.parallax2 !== false) this.parallax = this.parallax + 0.02;
    }),
      10;
    this.$nextTick(() => {
      //
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (to) {
      console.log("Lineup - beforeRouteUpdate");
    } else {
      console.log("else Lineup - beforeRouteUpdate");
    }
    // don't forget to call next()
  },
  beforeDestroy() {
    var elem = this.$refs.embedContainer.children[1];
    //console.log('elem: ', this.$refs.embedContainer.children[1]);
    elem.parentNode.removeChild(elem);

    var doStuffJs = document.getElementById("ds-fest-lineup-js");

    //console.log('beforeDestroy - 2', doStuffJs);
    doStuffJs.parentNode.removeChild(doStuffJs);

    var doStuffFestJs = document.getElementById("ds-fest");
  },
  destroyed() {
    window.removeEventListener("resize", this.sizing);
    window.removeEventListener("scroll", this.scrollBg);
    window.removeEventListener("load", this.sizing);
  },
};
</script>
